import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotHospital = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M34.4 39.076c-6.746 2.775-12.172-1.247-18.456-4.857C9.534 30.002-.79 31.317.048 22.86c.665-6.725 8.407-7.027 14.496-11.029C20.6 7.835 23.221 5.904 28.44 7.638c5.183 1.739 10.16 5.108 11.292 11.247 1.098 6.143-1.28 17.657-5.332 20.19Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M29.571 22.2h3.434a2.71 2.71 0 0 1 2.709 2.707v9.887c0 .509-.413.92-.922.92h-5.22m0-13.513V7.957a3.677 3.677 0 0 0-3.674-3.67H14.102a3.677 3.677 0 0 0-3.674 3.67v9.963M29.57 22.2v13.515M10.428 17.92h-3.68c-1.312 0-2.463 1.265-2.463 2.707v14.167c0 .509.413.92.922.92h5.22m0-17.794v17.795m0 0H17.1m12.472 0h-6.67m-5.802 0H22.9m-5.801 0v-8.53H22.9v8.53M20 12.509v-2.14m0 0v-2.14m0 2.14h-2.141m2.14 0h2.14m-7.854 6.06h2.857M14.285 22h2.857m5.715-5.571h2.857M22.857 22h2.857"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotHospital.displayName = "SpotHospital";
